import {
    Card,
    Table,
    Text,
    rem,
    useMantineColorScheme,
    ScrollArea
} from "@mantine/core";

interface PlaygroundDataTableProps {
    columns: string[];
    rows: any[];
}

export function PlaygroundDataTable({ columns, rows }: PlaygroundDataTableProps) {
    const { colorScheme } = useMantineColorScheme();
    const isDark = colorScheme === 'dark';

    return (
        <Card
            withBorder
            radius="md"
            p={0}
            style={{
                backgroundColor: isDark ? 'rgba(255, 255, 255, 0.03)' : undefined,
                borderColor: isDark ? 'rgba(255, 255, 255, 0.1)' : undefined,
                overflow: 'hidden',
            }}
        >
            <ScrollArea>
                <Table
                    highlightOnHover
                    stickyHeader
                    verticalSpacing="sm"
                    horizontalSpacing="md"
                    styles={{
                        th: {
                            backgroundColor: isDark
                                ? 'rgba(255, 255, 255, 0.03)'
                                : 'var(--mantine-color-gray-0)',
                            borderBottom: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.1)' : 'var(--mantine-color-gray-3)'}`,
                        },
                        td: {
                            borderColor: isDark ? 'rgba(255, 255, 255, 0.05)' : undefined,
                        }
                    }}
                >
                    <Table.Thead>
                        <Table.Tr>
                            {columns.map((col) => (
                                <Table.Th key={col} style={{ whiteSpace: 'nowrap' }}>
                                    <Text size="sm" fw={600}>{col}</Text>
                                </Table.Th>
                            ))}
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {rows.length === 0 ? (
                            <Table.Tr>
                                <Table.Td
                                    colSpan={columns.length}
                                    style={{ textAlign: 'center', padding: rem(48) }}
                                >
                                    <Text c="dimmed" size="sm">No data to display</Text>
                                </Table.Td>
                            </Table.Tr>
                        ) : (
                            rows.map((row, idx) => (
                                <Table.Tr
                                    key={idx}
                                    className={isDark ? 'dark:hover:bg-white/5' : 'hover:bg-gray-100/50'}
                                >
                                    {columns.map((col) => (
                                        <Table.Td key={col} style={{ whiteSpace: 'nowrap' }}>
                                            {row[col] === null || row[col] === undefined ? (
                                                <Text size="xs" c="dimmed" fs="italic">NULL</Text>
                                            ) : (
                                                <Text size="sm">{String(row[col])}</Text>
                                            )}
                                        </Table.Td>
                                    ))}
                                </Table.Tr>
                            ))
                        )}
                    </Table.Tbody>
                </Table>
            </ScrollArea>
        </Card>
    );
}
